

document.addEventListener('DOMContentLoaded', function () {

    if (new URLSearchParams(window.location.search).has('vv_reviews')) return;

  if (!document.querySelector('.jdgm-prev-badge, .jdgm-preview-badge')) return;

  const style = document.createElement('style');
  style.textContent = `
    .vv-reviews-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,.55);
      z-index: 2147483000;
      display: none;
      align-items: center;
      justify-content: center;
      padding: 16px;
    }
    .vv-reviews-overlay.is-open { display: flex; }
    .vv-reviews-modal {
      position: relative;
      background: #fff;
      color: #222;
      width: min(720px, 100%);
      max-height: 85dvh;
      overflow-y: auto;
      border-radius: 8px;
      padding: 40px 24px 24px;
    }
    .vv-reviews-close {
      position: absolute;
      right: 12px;
      top: 10px;
      border: 0;
      background: transparent;
      font-size: 30px;
      cursor: pointer;
      color: #222;
      z-index: 2;
    }
    .jdgm-prev-badge, .jdgm-preview-badge {
      cursor: pointer;
    }
    @media (max-width: 600px) {
      .vv-reviews-modal {
        padding: 42px 16px 20px;
        max-height: 90dvh;
      }
    }
  `;
  document.head.appendChild(style);

  const overlay = document.createElement('div');
  overlay.className = 'vv-reviews-overlay';
  overlay.innerHTML = `
    <div class="vv-reviews-modal" role="dialog"
         aria-modal="true" aria-label="Customer reviews">
      <button type="button" class="vv-reviews-close"
              aria-label="Close reviews">&times;</button>
      <div class="vv-reviews-content"></div>
    </div>
  `;
  document.body.appendChild(overlay);

  const content = overlay.querySelector('.vv-reviews-content');
  const closeButton = overlay.querySelector('.vv-reviews-close');
  let lastFocus = null;
  let previousOverflow = '';

  function moveReviews() {
    if (content.children.length) return true;

    const widget = document.querySelector(
      '#judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg'
    );

    if (!widget || overlay.contains(widget)) return false;

    const sourceSection = widget.closest('.shopify-section');
    content.appendChild(widget);

    if (sourceSection && !sourceSection.querySelector(
      '.jdgm-review-widget, .jdgm-rev-widg'
    )) {
      sourceSection.style.display = 'none';
    }
    return true;
  }

  function openReviews() {
    if (!moveReviews()) return;
    lastFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    closeButton.focus();
  }

  function closeReviews() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = previousOverflow;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  closeButton.addEventListener('click', closeReviews);

  overlay.addEventListener('click', function (event) {
    if (event.target === overlay) closeReviews();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeReviews();
    }
  });

  document.addEventListener('click', function (event) {
    const badge = event.target.closest(
      '.jdgm-prev-badge, .jdgm-preview-badge'
    );

    if (!badge || overlay.contains(badge)) return;
    event.preventDefault();
    event.stopPropagation();
    openReviews();
  }, true);

  moveReviews();
});




